let scrollPosition = 0;
function toggleSearchDrawer() {
  const drawer = document.getElementById("custom-search-drawer");
  const overlay = document.getElementById("search-drawer-overlay");
  drawer.classList.add("open");
  overlay.classList.add("active");
  // Store current scroll position
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  // Lock scrolling on all pages
  document.body.classList.add("search-drawer-open");
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
  // Disable fullpage.js scrolling if present
  if (typeof fullpage_api !== 'undefined') {
    fullpage_api.setAllowScrolling(false);
    fullpage_api.setKeyboardScrolling(false);
  }
  const firstBtn = document.querySelector("#category-buttons .category-button");
  if (firstBtn) {
    firstBtn.click();
  }
}
function closeSearchDrawer() {
  document.getElementById("custom-search-drawer").classList.remove("open");
  document.getElementById("search-drawer-overlay").classList.remove("active"); 
  // Restore scrolling on all pages
  document.body.classList.remove("search-drawer-open");
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollPosition);
  document.body.style.top = '';
  // Re-enable fullpage scrolling if present
  if (typeof fullpage_api !== 'undefined') {
    fullpage_api.setAllowScrolling(true);
    fullpage_api.setKeyboardScrolling(true);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const categoryButtons = document.querySelectorAll(".category-button");
  categoryButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      categoryButtons.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");
      const tag = this.dataset.tag;
      showProductsForTag(tag);
      updateViewAllLink(tag); // update View All URL
    });
  });
});
  function handleSearchInput(value) {
    if (value.length < 2) return;
    showProductsForTag(value);
    updateViewAllLink(value); // update View All URL
  }
function showProductsForTag(tag) {
  fetch(`/search/suggest.json?q=${encodeURIComponent(tag)}&resources[type]=product&resources[limit]=4`)
    .then((res) => res.json())
    .then((data) => {
      const products = data.resources.results.products.slice(0, 4);
      const container = document.getElementById("recommended-products");
      container.innerHTML = "";
      if (products.length === 0) {
        container.innerHTML = `<p style='font-size:13px;color:#777;'>No products found for "${tag}".</p>`;
        return;
      }
      products.forEach((product) => {
        const productHtml = `
          <div class="recommended-product">
            <a href="${product.url}" style="display: flex; gap: 8px;">
              <img src="${product.image}" alt="${product.title}" />
              <div class="recommended-info">
                <p>${product.title}</p>
                <span>${product.price}</span>
              </div>
            </a>
          </div>
        `;
        container.insertAdjacentHTML("beforeend", productHtml);
      });
    });
}
function updateViewAllLink(tag) {
  const viewAllLink = document.getElementById("view-all-link");
  if (!viewAllLink) return;
  const query = tag.trim();
  const encodedQuery = encodeURIComponent(query);
  viewAllLink.href = `/collections/sale`;
  // viewAllLink.href = `/search?q=${encodedQuery}&type=collection&source=search`;
}
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const searchButton = document.getElementById("search-button");
  function performSearch() {
    const query = searchInput.value.trim();
    if (query.length > 0) {
      const encodedQuery = encodeURIComponent(query);
      //URL:
      window.location.href = `/search?q=${encodedQuery}&type=collection&source=search`;
    }
  }
  // Enter key support
  searchInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      performSearch();
    }
  });
  // Search button click support (only if button exists)
  if (searchButton) {
    searchButton.addEventListener("click", performSearch);
  }
});